import { TranslatePipe } from "@ngx-translate/core";

import { ChangeDetectionStrategy, Component, input } from "@angular/core";
import { MatDialogClose } from "@angular/material/dialog";

import { SelfserviceAuthenticationBox } from "../selfservice-authentication-box/selfservice-authentication-box";

@Component({
  selector: "selfservice-unavailable",
  templateUrl: "selfservice-unavailable.html",
  styleUrl: "../selfservice-loader/selfservice-loader.scss",
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [MatDialogClose, SelfserviceAuthenticationBox, TranslatePipe],
})
export class SelfserviceUnavailable {
  protected title = input<string>("Selfservice.Global.UnavailableTitle");
}
